
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.707","height":"17.707"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.273 2.934a6.6 6.6 0 11-9.339 0 6.6 6.6 0 019.339 0zm0 9.339L17 17","fill":"none","stroke":"#007d57","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    